<template>
  <loading :loading="isLoading">
    <b-breadcrumb :items="breadcrumbs"/>
    <h2>Manage case</h2>
    <error :error="error"/>
    <div v-if="page">
      <b-row style="margin-bottom: 80px">
        <b-col>
          <h3>Case notes</h3>
          <b-form-textarea id="caseNotes"
            v-model="newCaseNotes"
            placeholder="Enter new case notes"
            style="margin-bottom: 6px"
            :rows="12"/>
          <b-button-group>
            <b-button variant="primary" @click="addACaseNote">{{ caseIsOpen ? 'Update' : 'Open' }} investigation</b-button>
            <b-button v-if="caseIsOpen" variant="secondary" @click="closeCase">Close Investigation</b-button>
            <b-button variant="danger" @click="goBack">Cancel</b-button>
          </b-button-group>
        </b-col>
        <b-col>
          <h3>Financial Returns: {{ page.FinancialReturns[0].reppub_financialreturn_current | currency }}</h3>
          <b-form-group
            id="financialReturnsReason"
            description="Reason for applying new savings (not required)"
            label="Reason"
            label-for="reason"><b-form-input id="reason" placeholder="Enter optional reason" v-model.number="financialReturnsReason"/>
          </b-form-group>
          <b-form-group
            id="financialReturnsFines"
            description="Fines applied"
            label="Fines £"
            label-for="fines"><b-form-input id="fines" placeholder="0.00" v-model.number="financialReturnsFines"/>
          </b-form-group>
          <b-form-group
            id="financialReturnsSaved"
            description="Amount saved"
            label="Saved £"
            label-for="saved"><b-form-input id="saved" placeholder="0.00" v-model.number="financialReturnsSaved"/>
          </b-form-group>
          <b-form-group
            id="financialReturnsRetro"
            description="Retrospectively recovered"
            label="Recovered £"
            label-for="retro"><b-form-input id="retro" placeholder="0.00" v-model.number="financialReturnsRetro"/>
          </b-form-group>
          <b-button variant="success" @click="addSavings">Apply</b-button>
        </b-col>
      </b-row>
      <b-card header="History">
        <b-table :items="page.CaseHistory" :fields="['username', 'description']">
          <template #head(username)>When/Who</template>
          <template #head(description)>What</template>
          <template #cell(username)="data">
            {{ data.item.happened_at | moment('Do MMM HH:mm') }} by <b>{{ data.item.username }}</b>
          </template>
        </b-table>
      </b-card>
    </div>
  </loading>
</template>

<script>
import Loading from '../components/Loading.vue'
import Error from '../components/Error.vue'

export default {
  components: { Loading, Error },
  data() {
    return {
      breadcrumbs: [
        {text: 'All Notifications', to: `/alerts/${this.$route.params.alert_category}`}, 
        {text: 'Notification', to: `/alerts/${this.$route.params.alert_category}/${this.$route.params.reference}`},
        {text: 'Investigation', active: true },
      ],
      newCaseNotes: null,
      financialReturnsFines: 0.0,
      financialReturnsSaved: 0.0,
      financialReturnsRetro: 0.0,
      financialReturnsReason: null,
      isLoading: true,
      page: null,
      error: null,
      category: this.$route.params.alert_category,
      reference: this.$route.params.reference,
    }
  },
  computed: {
    caseIsOpen() {
      return this.page && this.page.Investigation.length > 0 && this.page.Investigation[0].is_closed === false;
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      this.$reportingApi.renderPage('panessex', this.$store.state.oidcStore.access_token, {
        pageName: 'Investigate',
        parameters: {
          category: this.category,
          reference: this.reference,
        },
      })
      .then(page => { this.page = page; this.isLoading = false; })
      .catch(e => { this.error = e.message; this.isLoading = false; });
    },

    goBack() {
      this.$router.back(1);
    },

    addSavings() {
      this.isLoading = true;
      this.$reportingApi.runAction('panessex', this.$store.state.oidcStore.access_token, {
        actionName: 'AddSavings',
        parameters: {
          category: this.category,
          reference: this.reference,
          reason: this.financialReturnsReason, 
          fines: this.financialReturnsFines, 
          saved: this.financialReturnsSaved,
          retro: this.financialReturnsRetro,
        },
      })
      .then(() => {
        this.financialReturnsReason = null;
        this.financialReturnsFines = 0.0;
        this.financialReturnsSaved = 0.0;
        this.financialReturnsRetro = 0.0;
        this.fetchData();
        this.isLoading = false;
      })
      .catch(e => { this.error = e.message; this.isLoading = false; });
    },

    addACaseNote() {
      this.error = null;
      this.isLoading = true;1
      this.$reportingApi.runAction('panessex', this.$store.state.oidcStore.access_token, {
        actionName: 'AddCaseNotes',
        parameters: {
          category: this.category,
          reference: this.reference,
          notes: this.newCaseNotes || '',
        },
      })
      .then(() => {
        this.newCaseNotes = null;
        this.fetchData();
        this.isLoading = false;
      })
      .catch(e => { this.error = e.message; this.isLoading = false; });
    },

    closeCase() {
      if (!this.page || !this.page.Investigation) {
        this.error = 'Could not close case because investigation not loaded';
        return;
      }
      this.error = null;
      this.isLoading = true;
      const { access_token } = this.$store.state.oidcStore;
      this.$reportingApi.runAction('panessex', access_token, {
        actionName: 'CloseInvestigation',
        parameters: {
          id: this.page.Investigation[0].id,
          notes: this.newCaseNotes || '', 
        },
      })
      .then(() => {
        this.newCaseNotes = null;
        this.fetchData();
        this.isLoading = false;
      })
      .catch(e => { this.error = e.message; this.isLoading = false; });
    }
  },
};
</script>
